module.exports = __webpack_public_path__ + "img/check.9657c35a.png";